/* @flow */

import React from 'react'
import classNames from 'classnames'

import { changeHandlerToEventHandler } from '../helpers'

export default function Search(props: {
  value: ?string,
  onChange: (newValue: string) => void,
}) {
  const className = classNames('form-group', 'label-floating', {
    'is-empty': props.value == null || props.value === '',
  })

  return (
    <div className={className}>
      <input
        type="text"
        placeholder="Search"
        id="inputSearch"
        value={props.value || ''}
        onChange={changeHandlerToEventHandler(props.onChange)}
        className="h2 bg-transparent bb dark-gray tl w-100 mb2 b--moon-gray"
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Search.js